module.exports = __webpack_public_path__ + "img/1970East-057_WEB-min.ffae6b21.jpg";